// extracted by mini-css-extract-plugin
export default {"wrap":"Special_wrap__r9WgG","row":"Special_row__iz8XK","bg":"Special_bg__44V6h","desc":"Special_desc__C+eVh","videoWrap":"Special_videoWrap__ZcwWX"};